/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiExportOption, ApiExportRequest } from '@Model';
import type { HttpActions, ResponseResolver, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of BillingExportController.
 */
export class BillingExportRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls POST /exports/categories/{exportCategory}
     */
    public availableExports(exportCategory: string): Promise<Result<ApiExportOption[]>> {
        return this.http.post<Result<ApiExportOption[]>, undefined>(`/exports/categories/${exportCategory}`, undefined);
    }

    /**
     * Calls POST /exports/{exportName}/format/{target}
     */
    public export<TResponse = unknown>(request: ApiExportRequest, exportName: string, target: string, responseResolver?: ResponseResolver<TResponse>): Promise<TResponse> {
        return this.http.post<TResponse, ApiExportRequest>(`/exports/${exportName}/format/${target}`, request, undefined, responseResolver);
    }
}
